import { useSelector } from 'react-redux';
import { accountSelectors } from '../redux/modules/account';
import { Account } from '../common/types/Accounts';

export const useAllAccounts = (): Array<Account> =>
  useSelector(accountSelectors.selectAccounts);

export default useAllAccounts;
